import universal from 'react-universal-component';

export default universal(() => import('./StartBench'));



// WEBPACK FOOTER //
// ./src/app/views/StartBench/index.js